export var valuesAllowedToJoin = ["NoOne", "Everyone"];
/*

*/ 
//# sourceMappingURL=AllowedToJoin.js.map